import axios from "axios";
import { deleteLoginInfo, getRefreshToken, getToken, saveToken } from "./utils/localStorage";
import { generateTokenUrl } from "./utils/urls";


const instance = axios.create({
  baseURL: `${window.location.protocol}//`,
});

instance.all = axios.all;
instance.spread = axios.spread;

axios.interceptors.request.use(
  config => {
    const token = getToken()
  if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

// axios.interceptors.response.use(
//   response => {
//     return response;
//   },
//   function (error) {
//     const originalRequest = error.config;
//     if (error.response.status === 401) {
//       originalRequest._retry = true;
//       const refreshToken = getRefreshToken();
//       return axios
//       .post(generateTokenUrl(), null,)
//       .then(res => {
//         if (res.data.status_code === 201) {
//           const resData = res.data;
//           saveToken(resData.data.token.access, resData.data.token.refresh);

//           axios.defaults.headers.common["Authorization"] =
//             "Bearer " + getToken();
//           return axios(originalRequest);
//         }
//       });
//   }
//   else if(error.response.status === 403){
//     deleteLoginInfo();
//     window.location.reload()
//   }
//   return Promise.reject(error);
// }
// );
// export default instance;


axios.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const refreshToken = getRefreshToken();

      // Call refresh endpoint WITH existing access token,
      // NOT refresh token
      const res = await axios.post(generateTokenUrl());

      if (res.data?.status_code === 201) {
        const { access, refresh } = res.data.data.token;
        saveToken(access, refresh);

        originalRequest.headers["Authorization"] = "Bearer " + access;
        return axios(originalRequest);
      }
    }

    if (error.response?.status === 403) {
      deleteLoginInfo();
      window.location.reload();
    }

    return Promise.reject(error);
  }
);
